import * as React from 'react';
import { Checkbox, InputPrefix, TextBox } from '@progress/kendo-react-inputs';
import { IconWrap } from '@progress/kendo-react-common';
import { searchIcon } from '@progress/kendo-svg-icons';
import { Button } from '@progress/kendo-react-buttons';
/**
 * Represents the KendoReact GridColumnMenuColumnsList component.
 */
export var GridColumnMenuColumnsList = function (props) {
    var _a = React.useState(''), filter = _a[0], setFilter = _a[1];
    var selectedColumnsIds = React.useMemo(function () { return new Set(props.columnsState.map(function (c) { return c.id; })); }, [props.columnsState]);
    var filtered = React.useMemo(function () {
        return props.columns.filter(function (c) { var _a; return (_a = (c.title || c.field)) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(filter.toLowerCase()); });
    }, [props.columns, filter]);
    var state = props.columns.map(function (c) { return React.useState(selectedColumnsIds.has(c.id)); });
    var onApply = React.useCallback(function () {
        var nextColumns = props.columns.filter(function (_c, i) { return state[i][0]; });
        props.onColumnsChange.call(undefined, nextColumns);
        props.onCloseMenu.call(undefined);
    }, [state, props.columns, props.onColumnsChange, props.onCloseMenu]);
    var onReset = React.useCallback(function () {
        props.columns.forEach(function (c, i) {
            state[i][1](selectedColumnsIds.has(c.id));
        });
    }, [state, selectedColumnsIds, props.columns]);
    var checkedCount = state.filter(function (st) { return st[0]; }).length;
    var allSelected = checkedCount === state.length;
    var onSelectAll = React.useCallback(function () {
        state.forEach(function (st, i) {
            if (allSelected && i === 0) {
                st[1](true);
            }
            else {
                st[1](!allSelected);
            }
        });
    }, [state, allSelected]);
    return (React.createElement("form", { className: "k-filter-menu k-group k-reset" },
        React.createElement("div", { className: "k-filter-menu-container" },
            React.createElement(TextBox, { className: 'k-searchbox', value: filter, onChange: function (e) { return setFilter(String(e.target.value)); }, prefix: function () { return (React.createElement(React.Fragment, null,
                    React.createElement(InputPrefix, null,
                        React.createElement(IconWrap, { name: "search", icon: searchIcon })))); } }),
            React.createElement("ul", { className: "k-reset k-multicheck-wrap" },
                !filter && React.createElement("li", { className: "k-item k-check-all-wrap" },
                    React.createElement(Checkbox, { checked: allSelected, onChange: onSelectAll, label: '(Select all)' })),
                filtered.map(function (c, i) {
                    return (React.createElement("li", { key: c.id, className: "k-item" },
                        React.createElement(Checkbox, { disabled: state[i][0] && checkedCount === 1, checked: state[i][0], onChange: function (e) { var _a; return state[i][1](Boolean((_a = e.target.element) === null || _a === void 0 ? void 0 : _a.checked)); }, label: c.title || c.field })));
                })),
            React.createElement("div", { className: "k-filter-selected-items" },
                checkedCount,
                " selected items"),
            React.createElement("div", { className: "k-actions k-actions-start k-actions-horizontal" },
                React.createElement(Button, { type: "button", themeColor: 'primary', onClick: onApply }, "Apply"),
                React.createElement(Button, { type: "button", onClick: onReset }, "Reset")))));
};
GridColumnMenuColumnsList.displayName = 'GridColumnMenuColumnsList';
